module.exports = __webpack_public_path__ + "static/media/Raffrollo_35627_130x160.c595ed9e.png";